"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatementPrs = exports.StatementUt = exports.StatementTypeCategory = void 0;
var StatementTypeCategory;
(function (StatementTypeCategory) {
    StatementTypeCategory["All"] = "all";
    StatementTypeCategory["UT"] = "ut";
    StatementTypeCategory["PRS"] = "prs";
})(StatementTypeCategory || (exports.StatementTypeCategory = StatementTypeCategory = {}));
var StatementUt;
(function (StatementUt) {
    StatementUt["CWCAS"] = "CWCAS";
    StatementUt["CWCASX"] = "CWCASX";
    StatementUt["CWRAS"] = "CWRAS";
    StatementUt["CWSID"] = "CWSID";
    StatementUt["CWSOR"] = "CWSOR";
    StatementUt["PRSOR"] = "PRSOR";
    StatementUt["CWSOA"] = "CWSOA";
    StatementUt["CWUSS"] = "CWUSS";
    StatementUt["1KWMMF"] = "1KWMMF";
    StatementUt["2KWMMF"] = "2KWMMF";
    StatementUt["CWA4CEO"] = "CWA4CEO";
    StatementUt["CWASOA"] = "CWASOA";
    StatementUt["CWA4SOA"] = "CWA4SOA";
})(StatementUt || (exports.StatementUt = StatementUt = {}));
var StatementPrs;
(function (StatementPrs) {
    StatementPrs["WLTR1"] = "WLTR1";
    StatementPrs["WLTR1BOOK"] = "WLTR1BOOK";
    StatementPrs["WLTR2"] = "WLTR2";
    StatementPrs["WLTR2BOOK"] = "WLTR2BOOK";
    StatementPrs["WLTR3"] = "WLTR3";
    StatementPrs["WLTR3BOOK"] = "WLTR3BOOK";
    StatementPrs["PRSSOA"] = "PRSSOA";
    StatementPrs["PRSSOR"] = "PRSSOR";
    StatementPrs["PRSRWPWITD"] = "PRSRWPWITD";
    StatementPrs["PRSRWPENROL"] = "PRSRWPENROL";
    StatementPrs["PRSRWPCANCEL"] = "PRSRWPCANCEL";
    StatementPrs["PRSCAS"] = "PRSCAS";
    StatementPrs["PRSGHRSOA"] = "PRSGHRSOA";
    StatementPrs["PRSGHRSOR"] = "PRSGHRSOR";
})(StatementPrs || (exports.StatementPrs = StatementPrs = {}));
